import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconAssignmentLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.308 20.5a1.74 1.74 0 0 1-1.277-.531 1.74 1.74 0 0 1-.531-1.277V5.308c0-.497.177-.923.531-1.277A1.74 1.74 0 0 1 5.308 3.5h4.45a2.21 2.21 0 0 1 .727-1.416c.421-.39.928-.584 1.52-.584.591 0 1.098.195 1.52.584.422.389.66.86.717 1.416h4.45c.497 0 .923.177 1.277.531.354.354.531.78.531 1.277v13.384c0 .497-.177.923-.531 1.277a1.74 1.74 0 0 1-1.277.531H5.308Zm0-1.5h13.384a.294.294 0 0 0 .212-.096.294.294 0 0 0 .096-.212V5.308a.294.294 0 0 0-.096-.212.294.294 0 0 0-.212-.096H5.308a.294.294 0 0 0-.212.096.294.294 0 0 0-.096.212v13.384c0 .077.032.148.096.212a.294.294 0 0 0 .212.096ZM8 16.634h5c.213 0 .39-.071.534-.215a.725.725 0 0 0 .216-.535.725.725 0 0 0-.216-.534.726.726 0 0 0-.534-.215H8a.725.725 0 0 0-.534.215.726.726 0 0 0-.216.535c0 .213.072.39.216.534a.726.726 0 0 0 .534.215Zm0-3.884h8c.212 0 .39-.072.534-.216A.726.726 0 0 0 16.75 12a.725.725 0 0 0-.216-.534.726.726 0 0 0-.534-.216H8a.725.725 0 0 0-.534.216.726.726 0 0 0-.216.534c0 .213.072.391.216.534A.725.725 0 0 0 8 12.75Zm0-3.885h8c.212 0 .39-.072.534-.215a.726.726 0 0 0 .216-.535.725.725 0 0 0-.216-.534.726.726 0 0 0-.534-.216H8a.725.725 0 0 0-.534.216.725.725 0 0 0-.216.535c0 .212.072.39.216.534A.726.726 0 0 0 8 8.865Zm4-4.519a.728.728 0 0 0 .75-.75.728.728 0 0 0-.75-.75.728.728 0 0 0-.75.75.728.728 0 0 0 .75.75Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconAssignmentLine;
